import React, { useEffect, useState } from 'react';
import { Button, Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../../../components/Admin/GreetingsTop/GreetingsTop';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { METHOD_GET } from '../../../../utils/constants';
import { fetchApi } from '../../../../helpers/fetch';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getAccessTokenApi } from '../../../../api/auth';
import CustomerContactsTable from '../../../../components/PortalClients/Customers/CustomerContactsTable';

export default function CustomerContactsPage() {
    let { clientId } = useParams();
    const token = getAccessTokenApi();
    const [client, setClient] = useState({});

    useEffect(() => {
        const config = {
            method: METHOD_GET,
            url: `customer/${clientId}/contacts`,
            data: null,
            token,
        };
        fetchApi(config)
            .then((response) => {
                // console.log(response, 'response client');
                if (response) {
                    let clientt = response.result;
                    setClient(clientt);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [clientId, token]);

    return (
        <Layout>
            <GreetingsTop />

            <HeaderTop client={client}/>

            <div className="clients__container">
                <CustomerContactsTable client={client}/>
            </div>
        </Layout>
    );
}

function HeaderTop({client}) {
    const { Title } = Typography;
    let history = useHistory();
    return (
        <div className="clients__container">
            <Row xs={23} className="header-top">
                <Col xs={19} className="header-top__left">
                    <Title level={3}>Contactos {client.name}</Title>
                </Col>
                <Col xs={1}>
                    <Button type="link" onClick={() => history.goBack()}>
                        <ArrowLeftOutlined /> Atrás
                    </Button>
                </Col>
            </Row>
        </div>
    );
}
